import { css } from 'lit';
import componentStyles from '../styles/component.styles';
export default css `
${componentStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
  display: block;
}

.live-banner {

}

.live-banner ul {
  padding: 0;
  margin: 0;
  list-style: none;
}


/**
--------------------------------------------------
* Banner
--------------------------------------------------
*/
.banner-inner {
  padding-inline: var(--p-gap);
}

.contained .banner-inner {
  width: min(var(--p-container-width), 100% - 2 * var(--p-gap));
  margin-inline: auto;
  padding-inline: 0;
}

.banner.upcomming .banner-inner {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: .75rem;
  row-gap: .25rem;
  background-color: var(--p-bg);
  font-size: .875rem;
  padding-block: .5rem;
}

.banner.upcomming h2 {
  font-size: .875rem;
  font-weight: var(--p-body-font-weight);
  margin: 0;
}

.banner.upcomming + .banner.upcomming {
  border-top: 1px solid var(--p-border);
}

.banner.upcomming:last-of-type {
  border-bottom: 1px solid var(--p-border);
}


.banner.live {
  padding-block: .5rem;
  background-color: var(--p-bg-dark);
  --p-text-color: var(--p-text-color-light);
}

.banner .live-badge {
  top: 3px;
  left: 3px;
}

/**
--------------------------------------------------
* Preview
--------------------------------------------------
*/
.preview {
  outline: 3px dashed #E1E3E8;
  outline-offset: -10px;
  padding: 20px 0;
}

.preview .banner {
  border: 0!important;
}


`;
